import axios from "axios";

const init = () => {
    const signupForm = document.getElementById("quick-signup-form");
    const signupFormMessage = document.getElementById("quick-signup-message");
    const signupFormBtn = signupForm.querySelector("button");

    if (signupForm) {
        const handleFormSubmit = (e) => {
            e.preventDefault();

            signupFormBtn.setAttribute("disabled", "");

            const emailFld = signupForm.querySelector('[name="email"]');

            if (emailFld) {
                // First do reCaptcha check
                const captchaFld = signupForm.querySelector(
                    '[name="captcha-token"]'
                );

                if (captchaFld) {
                    // Get data from form element
                    let fd = new FormData();

                    fd.append("captcha-token", captchaFld.value);

                    // Add CSRF field to form data
                    fd.append(csrfTokenName, csrfTokenValue);

                    axios({
                        method: "post",
                        url: "/actions/captcha-module/default/verify-recaptcha-token",
                        data: fd,
                    })
                        .then((response) => {
                            // eventType = "ajax-form-response";
                            // eventDetail = response;

                            console.log(response);

                            if (response.data.success) {
                                // Get data from form element
                                fd = new FormData();

                                fd.append("email", emailFld.value);
                                fd.append("audienceId", "22506e9f15");

                                // Add CSRF field to form data
                                fd.append(csrfTokenName, csrfTokenValue);

                                axios({
                                    method: "post",
                                    url: "/actions/mailchimp-subscribe/audience/subscribe",
                                    data: fd,
                                })
                                    .then((r) => {
                                        console.log(r);

                                        if (r.status == 200) {
                                            signupFormMessage.innerHTML =
                                                "Thank you for signing up!";
                                        } else {
                                            signupFormMessage.innerHTML =
                                                r.statusText;
                                        }

                                        signupFormMessage.removeAttribute(
                                            "hidden"
                                        );
                                        signupFormBtn.removeAttribute(
                                            "disabled"
                                        );
                                    })
                                    .catch((err) => {
                                        console.log(err);

                                        signupFormMessage.innerHTML =
                                            "There was a problem subscribing you. Please try again.";
                                        signupFormMessage.removeAttribute(
                                            "hidden"
                                        );
                                        signupFormBtn.removeAttribute(
                                            "disabled"
                                        );
                                    });
                            }
                        })
                        .catch((error) => {
                            // eventType = "ajax-form-error";
                            // eventDetail = error;

                            console.log(error);

                            signupFormMessage.innerHTML =
                                "There was a problem subscribing you. Please try again.";
                            signupFormMessage.removeAttribute("hidden");
                            signupFormBtn.removeAttribute("disabled");
                        });
                }
            }
        };

        signupForm.addEventListener("submit", handleFormSubmit);
    }
};

export default init;
